<template>
  <div>
    <q-input
      v-bind="$attrs"
      ref="qInput"
      class="textInput gordita-400-12"
      :clearable="toBeClearable"
      dense
      tabindex="1"
      :type="type"
      input-class="login-input"
      bg-color="white"
      stack-label
      outlined
      lazy-rules
    >
      <template
        v-if="$slots.error"
        #error
      >
        <slot name="error" />
      </template>

      <template
        v-if="$slots.hint"
        #hint
      >
        <slot name="hint" />
      </template>
    </q-input>
  </div>
</template>

<script>
export default {
  name: 'IncrediTextInput',
  props: {
    toBeClearable: {
      // Don't display clear x icon
      default: true,
    },
    type: {
      default: 'text',
    },
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    validate() {
      return this.$refs.qInput.validate();
    },
  },
};
</script>

<style scoped lang="scss">
:deep(.q-field--disabled) {
  .q-field__native {
    color: $-text-text-lowest !important;
  }
}
.textInput {
  :deep(.q-field__control) {
    border-radius: 2px;
  }
}
</style>
